<span class="timesheet-info" [sbTooltip]="text" [sbTooltipDisabled]="!isTruncated">
  @if (text) {
    <span class="timesheet-info-text">{{ text }}</span>
    <shift-warning
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
      [deviatesFromSchedule]="deviatesFromSchedule"
    ></shift-warning>
  } @else {
    {{ 'External' | translate }}
  }
</span>
